import React, { useEffect, useState } from 'react';
import { useStore } from 'effector-react';
import type { HSIconImage, HSIconSeqFrame, HSIconVideo } from '@types';
import Tabbar from '@components/Tabbar';
import { $editingHotspot } from '@stores/editingHotspotStores';
import WidgetRow from '@components/PlayerWidgets/WidgetRow';
import IconScale from './IconScale';
import IconRX from './IconRX';
import IconRY from './IconRY';
import IconRZ from './IconRZ';
import IconAnchor from './IconAnchor';
import TabScale from './TabScale';
import TabRotate from './TabRotate';
import EdgeRow from '../EdgeRow';

function ImageScaleRow() {
  const [tab, setTab] = useState(0);
  const { hotspot } = useStore($editingHotspot)!;
  const icon = hotspot.icon as HSIconImage | HSIconSeqFrame | HSIconVideo;

  useEffect(() => {
    setTab(0);
  }, [icon.stick]);

  const tabs = icon.stick
    ? [
        <IconScale active={tab === 0} />,
        <IconRX active={tab === 1} />,
        <IconRY active={tab === 2} />,
        <IconRZ active={tab === 3} />,
        <IconAnchor active={tab === 4} />,
      ]
    : [<IconScale active={tab === 0} />, <IconAnchor active={tab === 1} />];
  return (
    <WidgetRow>
      <Tabbar
        className="mb-10"
        tabs={tabs}
        activeIndex={tab}
        onChange={setTab}
      />
      {tab === 0 && <TabScale />}
      {!!icon.stick && tab === 1 && (
        <TabRotate title="X轴旋转：" propKey="rx" />
      )}
      {tab === 2 && <TabRotate title="Y轴旋转：" propKey="ry" />}
      {tab === 3 && <TabRotate title="Z轴旋转：" propKey="rz" />}
      {(tab === 4 || (!icon.stick && tab === 1)) && <EdgeRow />}
    </WidgetRow>
  );
}

export default ImageScaleRow;
